export default function collapseNav(nextState) {
    var nav = document.querySelector('.navbar'),
        toggle;

    if (nav && nav.querySelector('.collapse.in')) {
        toggle = nav.querySelector('.navbar-toggler');

        toggle && toggle.click();
    }
};


// WEBPACK FOOTER //
// ./src/app/utils/collapseNav.js